export const GET_USER_INFO = 'getUserInfo';
export const GET_TOKEN = 'getToken';



// WEBPACK FOOTER //
// ./src/store/getters/type.js